// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Jr0-Q","logo":"Footer_logo__V0DL8"};